import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../Component/Common/Table";
import Pagination from "../../Component/Common/Pagination";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import Button from "../../Component/Common/Button";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import { warning } from "../../util/Alert";
import {
  deleteSubscription,
  getSubscriptions,
  selectEditPlan,
  togglePlanActiveStatus,
  togglePlanPopularStatus,
} from "../../store/subscription/subscription.action";

const AllPlans = ({ changeTab }) => {
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.loggedUser);
  const { subscriptionPlans, totalPlans } = useSelector(
    (state) => state.subscription,
  );
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleDeletePlan = (plan) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            dispatch(deleteSubscription(plan._id));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const monthlyPlans = subscriptionPlans
    .filter((plan) => plan.billingCycle === "monthly")
    .sort((a, b) => a.pricing.amount - b.pricing.amount);
  const yearlyPlans = subscriptionPlans
    .filter((plan) => plan.billingCycle === "yearly")
    .sort((a, b) => a.pricing.amount - b.pricing.amount);

  const plansMapData = [
    {
      Header: "Plan Type",
      Cell: ({ row }) => (
        <p className="mb-0 fw-semibold text-capitalize">{row.name}</p>
      ),
    },
    {
      Header: "Currency",
      Cell: ({ row }) => (
        <p className="mb-0 fw-semibold">{row.pricing.currency}</p>
      ),
    },
    {
      Header: "Price",
      Cell: ({ row }) => <p className="mb-0">{row.pricing.amount}</p>,
    },
    {
      Header: "Billing Cycle",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row.billingCycle}</p>
      ),
    },
    {
      Header: "Free Trial",
      Cell: ({ row }) => (row.hasTrial ? "Enabled" : "Disabled"),
    },
    {
      Header: "Trial Days",
      Cell: ({ row }) => <div>{row.trialDays}</div>,
    },

    {
      Header: "Features",
      Cell: ({ row }) => (
        <ul>
          {row.features?.map((feature) => (
            <li>{feature?.description}</li>
          ))}
        </ul>
      ),
    },
    {
      Header: "Limits",
      Cell: ({ row }) => (
        <div>
          <p className="mb-0">Courses : {row.limits.maxCourses}</p>
          <p className="mb-0">Videos : {row.limits.maxVideos}</p>
          <p className="mb-0">Members : {row.limits.maxMembers}</p>
        </div>
      ),
    },
    {
      Header: "Active",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isActive}
          onChange={() => dispatch(togglePlanActiveStatus(row._id))}
        />
      ),
    },
    {
      Header: "Popular",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isPopular}
          onChange={() => dispatch(togglePlanPopularStatus(row._id))}
        />
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center gap-2">
          <Button
            className="icon-btn"
            startIcon={<EditIcon />}
            onClick={() => {
              dispatch(selectEditPlan(row));
              changeTab();
            }}
          />
          {profile && !profile?.isSubAdmin ? (
            <Button
              className="icon-btn"
              startIcon={<TrashIcon />}
              onClick={() => handleDeletePlan(row)}
            />
          ) : null}
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getSubscriptions({ page, limit: size }));
  }, [dispatch, page, size]);

  return (
    <div>
      <Table
        data={[...monthlyPlans, ...yearlyPlans]}
        mapData={plansMapData}
        noDataMessage="No Plan Found!"
      />

      <div className="mt-3">
        <Pagination
          totalItem={totalPlans}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </div>
  );
};

export default AllPlans;
